
import axios from 'axios';
import BaseService from './base-service'
import ConfigurationService from './configuration-service';

const baseService = new BaseService();

class AuthService {

    constructor(){
    }

    static TOKEN_KEY = "@eurofarma-Token";

    static isAuthenticated = () => localStorage.getItem(AuthService.TOKEN_KEY) !== null;

    static getToken = () => localStorage.getItem(AuthService.TOKEN_KEY);

    static login = (token: any) => {
    localStorage.setItem(AuthService.TOKEN_KEY, token);
    };

    static logout = () => {
        localStorage.removeItem(AuthService.TOKEN_KEY);
    };

    static setTokenAuthenticationService = async () =>
    {
        var client_id = await ConfigurationService.getConfiguration('client_id');
        var userNameAuthentication = await ConfigurationService.getConfiguration('userNameAuthentication');
        var passwordAuthentication = await ConfigurationService.getConfiguration('passwordAuthentication');
        var base = await ConfigurationService.getConfiguration('ePharma.Authentication.Services.HTTPS');
        var endpoint = await ConfigurationService.getConfiguration('EndPoint.Authentication.Authenticate');

        var header = {
            headers: {
                'Content-Type': 'application/json',
                'username': userNameAuthentication,
                'password':  passwordAuthentication,
                'client_id':  client_id
            }
        };
        var result = await axios.get(base + endpoint, header);
        var token = result.data.data.token.accessToken;
 
        return token;
    }

    static setTokenOAuth = async () => {
        let token: string = "";
        var qs = require('qs');
        var client_id = await ConfigurationService.getConfiguration('client_idRest');
        var userNameRest = await ConfigurationService.getConfiguration('userNameRest');
        var passwordRest = await ConfigurationService.getConfiguration('passwordRest');
        var base = await ConfigurationService.getConfiguration('ePharma.Rest.Service');
        var endpoint = await ConfigurationService.getConfiguration('EndPoint.Token');

       await fetch(base + endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',

            },
            body: qs.stringify({
                'grant_type': 'password',
                'client_id': client_id,
                'client_secret': client_id,
                'username': userNameRest,
                'password': passwordRest
            }),
            mode: 'cors',
            credentials: 'same-origin'
        }).then(resp => resp.json()).then(data => {
            
            token = data.access_token;
        })

        return token;
    }
}

export default AuthService;